import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

// Sets/clears a single (mapping, date) rate override — a channel-specific
// price that supersedes the room/rate plan's normal computed rate only for
// that one channel (see backend PUT /api/channelmanager/mappings/:id/rate-override).
export const useChannelRateOverride = ({ onSaved }) => {
  const [modalState, setModalState] = useState(null); // { mappingId, dateKey, currentValue, baseValue, channelLabel }
  const [value, setValue] = useState("");

  const openModal = ({ mappingId, dateKey, currentValue, baseValue, channelLabel }) => {
    setModalState({ mappingId, dateKey, baseValue, channelLabel });
    setValue(currentValue ? String(currentValue) : "");
  };

  const closeModal = () => setModalState(null);

  const handleSave = async () => {
    if (!modalState) return;
    const price = value ? parseInt(value.replace(/\./g, ""), 10) : null;
    try {
      await axios.put(
        `/api/channelmanager/mappings/${modalState.mappingId}/rate-override`,
        { dates: { [modalState.dateKey]: price } }
      );
      Swal.fire("Saved", "Channel rate updated.", "success");
      closeModal();
      onSaved?.();
    } catch (error) {
      Swal.fire("Error", "Failed to update channel rate", "error");
    }
  };

  const handleClear = async () => {
    if (!modalState) return;
    setValue("");
    try {
      await axios.put(
        `/api/channelmanager/mappings/${modalState.mappingId}/rate-override`,
        { dates: { [modalState.dateKey]: null } }
      );
      Swal.fire("Cleared", "Reverted to the default rate for this channel.", "success");
      closeModal();
      onSaved?.();
    } catch (error) {
      Swal.fire("Error", "Failed to clear channel rate override", "error");
    }
  };

  return { modalState, value, setValue, openModal, closeModal, handleSave, handleClear };
};
